import React from 'react'

interface CarrierLogoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'className'> {
  src: string;
  size?: 'default' | 'large';
}

export function CarrierLogo ({ alt, 'aria-hidden': ariaHidden, src, size = 'default', ...props }: CarrierLogoProps) {
  const containerClasses = size === 'large'
    ? 'h-[64px] w-[90px] shrink-0 bg-white rounded-md border border-gray-200 p-1 flex items-center justify-center'
    : 'h-10 w-14 shrink-0 bg-white rounded-md border border-gray-200 p-1 flex items-center justify-center'

  return (
    <div className={containerClasses}>
      <img
        {...props}
        alt={alt}
        aria-hidden={ariaHidden}
        src={src}
        className='block object-contain h-full w-full'
      />
    </div>
  )
}
